import css from 'styled-jsx/css';
import { colors, zIndex } from '../../../../../config/styles';

const PDPBasicInfoDesktopStyle = css`
  .pdp-basic-info {
    width: 100%;
    text-align: left;

    .pdp-basic-info__header {
      display: block;
      text-align: left;
      margin-bottom: 8px;
    }

    .pdp-basic-info__title-container {
      display: block;
      text-align: left;
      line-height: 1.4;
    }

    .pdp-basic-info__brand-and-separator {
      white-space: nowrap;
      flex-shrink: 0;
      display: inline-flex;
      align-items: baseline;
      gap: 4px;
    }

    .pdp-basic-info__brand-link {
      color: ${colors.gray.shade52};
      text-decoration: none;
      font-size: 14px;
      letter-spacing: 1px;
    }

    .pdp-basic-info__brand-link:hover {
      text-decoration: underline;
    }

    .pdp-basic-info__separator {
      color: ${colors.gray.shade44};
    }

    .pdp-basic-info__product-name {
      font-weight: 400;
      font-size: 18px;
      margin: 0;
      word-wrap: break-word;
      overflow-wrap: break-word;
      line-height: 1.4;
      display: inline;
      margin-left: 4px;
    }

    .pdp-basic-info__seller {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;
    }

    .tooltipContent {
      z-index: ${zIndex.popover.content};
    }
  }
`;

export { PDPBasicInfoDesktopStyle };
